import ProductSlate from './ProductSlate'

export default ProductSlate
